export const readStream = async (stream: ReadableStream) => {
  const reader = stream.getReader();
  let result = "";

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      // value is a Uint8Array, convert it to text
      result += new TextDecoder().decode(value);
    }
    return result;
  } finally {
    reader.releaseLock();
  }
};
